import type {MediaType} from 'web-app/react/components/file-upload/types';

export const TAGGABLE_MEDIA_TYPES: Exclude<MediaType, 'File'>[] = ['Image', 'Video'];
